import React from "react";
import { CloseCircleOutlined } from "@ant-design/icons";
import { Button, Result, Typography } from "antd";
import { useHistory } from "react-router-dom";
// import Logo from "../../images/logo.png";
// import { PayHeader } from "../Paymentheader/PayHeader";

const { Paragraph, Text } = Typography;
// import { Button, Result } from "antd";

// import { useHistory } from "react-router-dom";

export const Error = () => {
  const history = useHistory();

  const handleButton = () => {
    // localStorage.removeItem("info3");
    history.push("/paydetails");
  };
  return (
    <>
     <Result
    status="error"
    // status="500"
    title="Submission Failed"
    subTitle="Please check and modify the following information before resubmitting."
    extra={[
      <Button type="primary" key="console" onClick={handleButton}>
        Retry Payment
      </Button>,
      //   <Button key="buy">Buy Again</Button>,
    ]}
  >
    <div className="desc-err">
      <div className="error-inner">
        <Paragraph>
          <Text
            strong
            style={{
              fontSize: 16,
            }}
          >
            The content you submitted has the following error:
          </Text>
        </Paragraph>
        <Paragraph className="parag-err-cntnt">
          <CloseCircleOutlined className="site-result-demo-error-icon" />{" "}
          Your account has been frozen.
        </Paragraph>
        <Paragraph className="parag-err-cntnt">
          <CloseCircleOutlined className="site-result-demo-error-icon" />{" "}
          Your account is not yet eligible to apply.
        </Paragraph>
      </div>
    </div>
  </Result>
    </>
   
  );
};
